import { get, post } from './axios.js'

/**
 * user 조회 - /userInfo/userSelect
 * @param {object} params
 * @property {string} params.user_id - 아이디
 * @returns
 */
export async function userSelect(params = {}) {
  try {
    const result = await post('/userInfo/userSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 사용자 목록 조회 - /userInfo/userList
 * @returns
 */
export async function userList(params = {}) {
  try {
    const result = await post('/userInfo/userList',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 사용자 조회 - /userInfo/userSearch
 * @param {object} params
 * @property {string} params.user_id - 아이디
 * @property {string} params.user_nm - 이름
 * @property {string} params.employee_id - 사번
 * @property {string} params.enable_yn - 활성화 상태
 * @returns
 */
export async function userSearch(params = {}) {
  try {
    const result = await post('/userInfo/userSearch', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 아이디 조회 (아이디 중복확인) - /userInfo/idCheck
 * @param {object} params
 * @property {string} params.user_id - 아이디
 * @returns
 */
export async function idCheck(params = {}) {
  try {
    const result = await post('/userInfo/idCheck', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 신규생성 사번 가져오기 - /userInfo/getNewEmployeeID
 * @returns
 */
export async function getNewEmployeeID() {
  try {
    const result = await post('/userInfo/getNewEmployeeID', {})
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 사용자 등록/수정 - /userInfo/userEdit
 * @param {object} params
 * @property {string} params.user_seq - seq
 * @property {string} params.user_nm - 이름
 * @property {string} params.employee_id - 사번
 * @property {string} params.user_id - 아이디
 * @property {string} params.dept_nm - 부서
 * @property {string} params.dept_cd - 부서코드
 * @property {string} params.up_dept_cd - 상위부서코드
 * @property {string} params.mobile - 휴대폰
 * @property {string} params.passwd - 비밀번호
 * @property {string} params.retire_yn - 재직여부
 * @property {string} params.auth_grp_id - 사용자유형
 * @property {string} params.enable_yn - 활성화
 * @property {object} params.attachFileVO
 * @property {string} params.file_seq
 * @property {string} params.del_file_seq
 * @property {string} params.file_div_id
 * @returns
 */
export async function userEdit(params = {}) {
  try {
    const result = await post('/userInfo/userEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 권한 서브 리스트 - /userInfo/getPrivilegeUsrSubList
 * @param {object} params
 * @property {string} params.auth_grp_id - 사용자유형
 * @returns
 */
export async function getPrivilegeUsrSubList(params = {}) {
  try {
    const result = await post('/userInfo/getPrivilegeUsrSubList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 권한 담당자 삭제 - /userInfo/privilegeUserDelete
 * @param {object} params
 * @property {string} params.auth_grp_seq - 사용자유형seq
 * @property {string} params.auth_grp_id - 사용자유형
 * @property {string} params.upd_id - 아이디
 * @returns
 */
export async function privilegeUserDelete(params = {}) {
  try {
    const result = await post('/userInfo/privilegeUserDelete', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 권한 유저 등록/수정 - /userInfo/privilegeUserEdit
 * @param {object} params
 * @property {string} params.auth_grp_seq - 사용자유형seq
 * @property {string} params.auth_grp_id - 사용자유형
 * @property {string} params.auth_grp_nm - 사용자유형이름
 * @property {string} params.editable - 수정여부
 * @property {string} params.fmt_reg_dt
 * @property {string} params.fmt_upd_dt
 * @property {string} params.up_priv_cd
 * @property {string} params.xcnt
 * @returns
 */
export async function privilegeUserEdit(params = {}) {
  try {
    const result = await post('/userInfo/privilegeUserEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 권한 상세 상태 갱신 - /userInfo/privilegeUserDetailSave
 * @param {object} params
 * @property {object} params.privilegeListVO
 * @returns
 */
export async function privilegeUserDetailSave(params = {}) {
  try {
    const result = await post('/userInfo/privilegeUserDetailSave', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 권한 그룹 조회 - /userInfo/getAuthGrpList
 * @param {object} params
 * @returns
 */
export async function getAuthGrpList(params = {}) {
  try {
    const result = await post('/userInfo/getAuthGrpList',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 권한 그룹 추가/수정 - /userInfo/getAuthGrpInsert
 * @param {object} params
 * @property {String} params.auth_grp_id 그룹 아이디
 * @property {String} params.auth_grp_nm 그룹 이름
 * @property {String} params.ss_user_id login id
 * @returns
 */
export async function getAuthGrpInsert(params = {}) {
  try {
    const result = await post('/userInfo/getAuthGrpInsert',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 권한 그룹 추가/수정 - /userInfo/getAuthGrpUpdate
 * @param {object} params
 * @property {String} params.auth_grp_id 그룹 아이디
 * @property {String} params.auth_grp_nm 그룹 이름
 * @property {String} params.ss_user_id login id
 * @returns
 */
export async function getAuthGrpUpdate(params = {}) {
  try {
    const result = await post('/userInfo/getAuthGrpUpdate',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 권한 그룹 삭제 - /userInfo/getAuthGrpDelete
 * @param {object} params
 * @property {String} params.user_auth_seq seq
 * @returns
 */
export async function getAuthGrpDelete(params = {}) {
  try {
    const result = await post('/userInfo/getAuthGrpDelete',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 권한 그룹 - 메뉴목록  - /userInfo/getAuthGrpMenuList
 * @param {object} params
 * @property {String} params.auth_grp_id auth_grp_id
 * @returns
 */
export async function getAuthGrpMenuList(params = {}) {
  try {
    const result = await post('/userInfo/getAuthGrpMenuList',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 권한 그룹 - 메뉴권한 수정  - /userInfo/userAuthGrpMenuEdit
 * @param {object} params
 * @property {String} params.auth_grp_id auth_grp_id
 * @property {Array} params.userAuthMnuListVO auth_grp_id
 * @returns
 */
export async function userAuthGrpMenuEdit(params = {}) {
  try {
    const result = await post('/userInfo/userAuthGrpMenuEdit',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}